export default function onTableRowSortingStart({ node }) {
  // sets column width for dragged row according to original row
  const tds = document.getElementsByClassName('table-row-sorting')[0].childNodes;
  node.childNodes.forEach((childNode, idx) => {
    tds[idx].style.width = `${childNode.offsetWidth}px`;
  });
}
